import * as constActions from './InstalledSoftwareConstsActions';
import initialState from './InstalledSoftwareInitialState';

export default function InstalledSoftwareReducer(state = initialState, action) {
  switch (action.type) {
    /* Get Arp Entries Columns */
    case constActions.GET_INSTALLED_SOFTWARE_COLUMNS_REQUEST: {
      return state;
    }
    case constActions.GET_INSTALLED_SOFTWARE_COLUMNS_SUCCESS: {
      return Object.assign({}, state, {
        columns: action.results
      });
    }
    case constActions.GET_INSTALLED_SOFTWARE_COLUMNS_FAILURE: {
      return state;
    }

    /* Get Arp Entries */
    case constActions.GET_INSTALLED_SOFTWARE_REQUEST: {
      return state;
    }
    case constActions.GET_INSTALLED_SOFTWARE_FAILURE: {
      return state;
    }
    case constActions.GET_INITIAL_INSTALLED_SOFTWARE_SUCCESS: {
      return Object.assign({}, state, {
        results: [...action.results]
      });
    }
    case constActions.GET_INSTALLED_SOFTWARE_SUCCESS: {
      return Object.assign({}, state, {
        results: [...state.results, ...action.results]
      });
      // return Object.assign({}, state, {
      //     results: [...state.results, ...action.results]
      // });
    }

    /* Save search parameters */
    case constActions.SAVE_INSTALLED_SOFTWARE_SEARCH_PARAMETERS: {
      return Object.assign({}, state, {
        parameters: action.parameters
      });
    }

    /* Select Arp Entries */
    case constActions.SELECT_INSTALLED_SOFTWARE_SUCCESS: {
      return Object.assign({}, state, {
        selectedInstalledSoftware: JSON.parse(JSON.stringify(action.selectedInstalledSoftware))
      });
    }
    case constActions.SELECT_ALL_INSTALLED_SOFTWARE_SUCCESS: {
      return Object.assign({}, state, {
        isSelectAllChecked: action.isSelectAllChecked
      });
    }
    default:
      return state;
  }
}
